import React, { useState, useEffect, useRef } from "react";
import Zoom from "react-reveal/Zoom";


import aim100 from "./Img/aimhundred.webp";
import great from "./Img/greatbook.webp";
import boland from "./Img/boland.webp";

import cgenial from "./Img/Cgenial.webp";
import Faqweb from "./Img/Faqweb.webp";
import Faqmob from "./Img/faqmob.webp";

import aim_hundred from "./Img/aimhundred.webp";
import c2c from "./Img/C2C.webp";
import fruit_e_commerce from "./Img/Fruitecom.webp";
import Order2go from "./Img/ordertogo.webp";
import Marsa from "./Img/marsa.webp";
import marsa_mobile from "./Img/marsa.webp";

import khatmah from "./Img/Khatmah.webp";
import lft from "./Img/lft.webp";
import madrasamobile from "./Img/Madrasa.webp";
import tongcast from "./Img/TONGCAST.webp";
import smb from "./Img/Smbiz.webp";
import "./style.css"


var data = [
 
  // {
  //   img: great,
  //   type: "Web Technology",
  //   name: "Great Booking",
  //   filter: ["all", "web"],
  //   link: "https://icbc.greatbooking.ca/",
  // },
  // {
  //   img: smb,
  //   type: "Web Technology",
  //   name: "SM BIZ SOLUTIONS",
  //   filter: ["all", "web"],
  //   link: "https://qcodesinfotech.com/" + smb,
  // },
  
  // {
  //   img: cgenial,
  //   type: "Web Technology",
  //   name: "C Genial Production",
  //   filter: ["all", "web"],
  //   link: "http://cgenialproduction.qcodesinfotech.com/",
  // },

  // {
  //   img: boland,
  //   type: "Web Technology",
  //   name: "Boland Survey",
  //   filter: ["all", "web"],
  //   link: "https://survey.bolandsurvey.com/",
  // },


  // {
  //   img: Order2go,
  //   type: "Web Technology",
  //   name: "Order2go",
  //   filter: ["all", "web", "e-comm"],
  //   link: "https://qcodesinfotech.com/" + Order2go,
  // },
  {
    img: Faqweb,
    type: "Web Technology",
    name: "FastinQueue",
    filter: ["all", "web", "e-comm"],
    link: "https://play.google.com/store/apps/details?id=com.marsa.store&hl=en-IN",
  },
  // {
  //   img: Marsa,
  //   type: "Web Technology",
  //   name: "Marsa Store",
  //   filter: ["all", "web", "e-comm"],
  //   link: "https://play.google.com/store/apps/details?id=com.marsa.store&hl=en-IN",
  // },
  {
    img: Faqmob,
    type: "Mobile Technology",
    name: "Fastin Queue Mobile",
    filter: ["all", "mobile"],
    link: "https://play.google.com/store/apps/details?id=com.qci.aimhundredapp",
  },
  // {
  //   img: aim_hundred,
  //   type: "Mobile Technology",
  //   name: "Aim Hundred",
  //   filter: ["all", "mobile"],
  //   link: "https://play.google.com/store/apps/details?id=com.qci.aimhundredapp",
  // },

  // {
  //   img: c2c,
  //   type: "Mobile Technology",
  //   name: "C2C",
  //   filter: ["all", "mobile"],
  //   link: "https://qcodesinfotech.com/" + c2c,
  // },
 
  // {
  //   img: fruit_e_commerce,
  //   type: "Mobile Technology",
  //   name: "Fruit E-commerce",
  //   filter: ["all", "mobile", "e-comm"],
  //   link: "https://qcodesinfotech.com/" + fruit_e_commerce,
  // },
    // {
    //   img: marsa_mobile,
    //   type: "Mobile Technology",
    //   name: "Marsa Store",
    //   filter: ["all", "mobile", "e-comm"],
    //   link: "https://qcodesinfotech.com/" + marsa_mobile,
    // },
  
 
 
  // {
  //   img: madrasamobile,
  //   type: "Mobile Technology",
  //   name: "Madrasa App",
  //   filter: ["all", "mobile"],
  //   link: "https://qcodesinfotech.com/" + madrasamobile,
  // },
  // {
  //   img: khatmah,
  //   type: "Mobile Technology",
  //   name: "Group Khatmah",
  //   filter: ["all", "mobile"],
  //   link: "https://play.google.com/store/apps/details?id=com.qci.khatmaapp",
  // },
// {
//     img: lft,
//     type: "Mobile Technology",
//     name: "LFT",
//     filter: ["all", "mobile"],
//     link: "https://qcodesinfotech.com/" + lft,
//   },


//   {
//     img: tongcast,
//     type: "Mobile Technology",
//     name: "TongCast",
//     filter: ["all", "mobile"],
//     link: "https://qcodesinfotech.com/" + tongcast,
//   },

];

function Portfolioinfo() {
  const [type, setTabType] = useState("all");

  const setType = (tab) => {
    setTabType(tab);
    localStorage.setItem("portfolio-tab", tab);
  };

  useEffect(() => {
    const tabtype = localStorage.getItem("portfolio-tab");
    if (tabtype) {
      setTabType(tabtype);
    }
  }, []);
 
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth" // Optional: adds smooth scrolling animation
    });
  }, []);


  return (
    <>
    <section className="inner-banner-wrap" style={{ overflowX: "hidden" }}>
        <div
          className="inner-baner-container"
          style={{ backgroundImage: "url(assets/images/banner-pattern1.png)" }}
        >
          <div className="container">
            <div className="inner-banner-content">
              <h1 className="inner-title" data-aos="fade-up">Portfolio</h1>
            </div>
          </div>
        </div>
      </section>
    <div className="portfolio m-b30" id="portfolio">
      
      <div className="section-full content-inner exp-services d-none">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className=" text-center  text-black">
                {/* <h2 className="text-gray-dark box-title m-b10 text-black">Portfolio</h2>
                <h3 className="box-title m-tb0">
                  Web &amp; Mobile Portfolio <span className="bg-primary" />
                </h3> */}
                <p className="font-weight-300 font-16 text-secondary mt-1">
                At Qcodes Infotech, we pride ourselves on delivering
                    high-quality, innovative solutions to our clients. Our team
                    of experienced developers and designers are committed to
                    providing tailored solutions that meet the specific needs of
                    each of our clients. We offer various services, including
                    custom software development, mobile app development, website
                    design and development, and data analytics and
                    visualization. We have a proven track record of success in
                    delivering projects on time and within budget, and we are
                    dedicated to providing exceptional customer service and
                    support. Some of our notable projects include a CRM system
                    for a large retail chain, a mobile app for a national
                    restaurant chain, and a data analytics platform for a
                    healthcare organization. Our team has the expertise and
                    experience to handle projects of any size and complexity,
                    and we are always looking for new challenges to tackle. We
                    believe that by working closely with our clients and
                    understanding their unique needs, we can deliver solutions
                    that meet and exceed their expectations. We will love to
                    speak with you if you are looking for a reliable,
                    experienced software development team to take your project
                    to the next level.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="site-filters clearfix center m-b40">
          <ul className="filters" data-bs-toggle="buttons">
            <li className={type === "all" ? "active" : ""}>
              <button
                className="site-button-secondry radius-sm"
                onClick={() => setType("all")}
              >
                <span>All</span>
              </button>
            </li>
            <li className={type === "web" ? "active" : ""}>
              <button
                className="site-button-secondry radius-sm"
                onClick={() => setType("web")}
              >
                <span>Web</span>
              </button>
            </li>
            <li className={type === "e-comm" ? "active" : ""}>
              <button
                className="site-button-secondry radius-sm"
                onClick={() => setType("e-comm")}
              >
                <span>Ecommerce</span>
              </button>
            </li>
            <li className={type === "mobile" ? "active" : ""}>
              <button
                className="site-button-secondry radius-sm"
                onClick={() => setType("mobile")}
              >
                <span>Mobile</span>
              </button>
            </li>
          </ul>
        </div>

        <div className="clearfix">
  <ul className="row dlab-gallery-listing gallery-grid-4 gallery mfp-gallery port-style1">
    {data
      .filter((i) => type === "all" || i.filter.includes(type))
      .map((item, index) => (
        <Zoom key={index}>
          <li
            className={`card-container col-lg-4 col-md-6 col-sm-6 p-a0 wow zoomIn ${item.filter.join(" ")}`}
            data-wow-delay="0.4s"
           
          >
            <div className="dlab-box dlab-gallery-box">
              <div className="dlab-media dlab-img-overlay1 dlab-img-effect">
                <img
                  src={item.img}
                  alt={item.name}
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "contain",
                    display: "block"
                  }}
                />
                <div className="overlay-bx">
                  <div className="overlay-icon align-b text-white">
                    <div className="text-white text-left port-box">
                      <h5 className="portfolio-item-title">
                        <a
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="portfolio-link"
                          onClick={(e) => e.stopPropagation()}
                        >
                          {item.name}
                        </a>
                      </h5>
                      <p className="ms">{item.type}</p>
                      <a
                        href={item.img}
                        className="mfp-link portfolio-fullscreen"
                        title={item.name}
                        onClick={(e) => {
                          e.preventDefault();
                          // Initialize Magnific Popup if not already done
                          // if (window.$.magnificPopup) {
                          //   window.$.magnificPopup.open({
                          //     items: {
                          //       src: item.img
                          //     },
                          //     type: 'image',
                          //     closeOnContentClick: true,
                          //     mainClass: 'mfp-img-mobile',
                          //     image: {
                          //       verticalFit: true
                          //     }
                          //   });
                          // }
                        }}
                      >
                        {/* <i className="bi bi-fullscreen text-black icon-bx-xs fullscreen-icon" /> */}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
       </Zoom>
      ))}
  </ul>
</div>
      </div>
    </div>
    </>
  );
}

export default Portfolioinfo;




